module.exports = __webpack_public_path__ + "static/media/hip.d0510bd4.svg";